module.exports = __webpack_public_path__ + "img/crowdfunding-circle.32bc3994.svg";